import { Box } from "@chakra-ui/react";
import { BLUE_300 } from "styles/theme";
import { IIconBadgeProps } from "./interfaces";

/** Round translucent-blue badge holding a header icon, used on the glass system screens. */
export function IconBadge({ children }: IIconBadgeProps) {
  return (
    <Box
      w="64px"
      h="64px"
      mx="auto"
      borderRadius="full"
      bg="rgba(56, 100, 255, 0.15)"
      backdropFilter="blur(12px)"
      color={BLUE_300}
      display="flex"
      alignItems="center"
      justifyContent="center"
      fontSize="28px"
    >
      {children}
    </Box>
  );
}
